import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="container not-found">
      <div class="w-100 text-center py-4">
        <i class="material-icons not-found-icon">info</i>
        <span i18n="Message displayed when the requested page is not found|Aka 404">Page not found.</span>
      </div>
    </div>
  `,
  styles: [
    `
      .not-found {
        height: 100%;
        display: flex;
        align-items: center;
      }
      .not-found-icon {
        color: #b71540;
        display: inline-block;
        width: 100%;
        font-size: 60px;
      }
    `,
  ],
})
export class NotFoundComponent {
  constructor() {}
}
